export default __webpack_public_path__ + "static/media/greenStar.28082d1e.svg";